import {trans} from '@frontend/helpers'
import {Modal} from 'swayok-react-mdb-ui-kit/components/Modal/Modal'
import {ModalBody} from 'swayok-react-mdb-ui-kit/components/Modal/ModalBody'
import {ModalContent} from 'swayok-react-mdb-ui-kit/components/Modal/ModalContent'
import {ModalHeader} from 'swayok-react-mdb-ui-kit/components/Modal/ModalHeader'
import type {SellerDetailsData} from '../SellerInfoModuleTypes'
import {SellerReviewsList} from './SellerReviewsList'

interface Props {
    seller: SellerDetailsData
    show: boolean | null
    onClose: () => void
    onClosed?: () => void
}

// Окно со списком отзывов о продавце.
export function SellerReviewsListModal(props: Props) {

    const {
        seller,
        onClose,
        ...modalProps
    } = props

    return (
        <Modal
            {...modalProps}
            size="lg"
            staticBackdrop
            scrollable
            closeOnEsc
        >
            <ModalContent>
                <ModalHeader
                    title={trans().seller.reviews.header(seller.name)}
                    onClose={onClose}
                    className="ps-sm-4"
                />
                <ModalBody className="px-sm-4 pb-4">
                    <SellerReviewsList seller={seller} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
